<template>
  <div
    class="hidden lg:block sticky top-0 z-[999] shrink-0 border-b border-slate-200 dark:border-zinc-800/80 bg-white/80 dark:bg-[#0f131c]/80 backdrop-blur-md transition-colors duration-300"
  >
    <div class="container lg:w-12/12 xl:w-12/12 2xl:w-11/12 mx-auto px-4 sm:px-6 lg:px-8 2xl:px-0">
      <div
        class="flex flex-1 items-center justify-between gap-x-2 xl:gap-x-3 2xl:gap-x-6 mx-auto py-2.5 2xl:py-3.5"
      >
        <div class="relative flex items-center gap-2.5 xl:gap-4 2xl:gap-6 shrink-0">
          <router-link :to="{ name: 'HomePage' }" class="shrink-0 flex items-center">
            <img
              class="h-8 2xl:h-9 w-auto shrink-0 inline dark:hidden"
              src="./assets/Momentum-light-Logo.svg"
              alt="Momentify Logo"
            />

            <img
              class="h-8 2xl:h-9 w-auto shrink-0 hidden dark:inline"
              src="./assets/Momentum-dark-Logo.svg"
              alt="Momentify Logo"
            />
          </router-link>
          <!-- <AiAssistant /> -->
          <div class="relative flex items-center gap-1.5 xl:gap-2.5 2xl:gap-3 shrink-0">
            <router-link
              :to="{ name: 'LearnPage' }"
              class="text-[11px] xl:text-xs font-semibold text-slate-700 dark:text-slate-300 bg-white/80 dark:bg-zinc-800/80 hover:bg-amber-500/10 dark:hover:bg-amber-500/20 hover:text-amber-700 dark:hover:text-[#ffd688] hover:border-amber-500/40 gap-1.5 2xl:gap-2 whitespace-nowrap flex items-center border border-slate-200 dark:border-zinc-700/80 rounded-full px-2.5 py-1.5 xl:px-3 2xl:px-4 2xl:py-2 transition-all duration-200 active:scale-95 cursor-pointer shadow-xs uppercase shrink-0"
            >
              <div class="text-[#d79900] dark:text-[#ffd688]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-book-open"
                >
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                </svg>
              </div>

              <span>Learn</span>
            </router-link>

            <!-- Sample Strategies Button (replacing Explore Strategies dropdown) -->
            <router-link
              v-if="initials"
              :to="{ name: 'SampleStrategiesPage' }"
              class="text-[11px] xl:text-xs font-semibold text-slate-700 dark:text-slate-300 bg-white/80 dark:bg-zinc-800/80 hover:bg-amber-500/10 dark:hover:bg-amber-500/20 hover:text-amber-700 dark:hover:text-[#ffd688] hover:border-amber-500/40 gap-1.5 2xl:gap-2 whitespace-nowrap flex items-center border border-slate-200 dark:border-zinc-700/80 rounded-full px-2.5 py-1.5 xl:px-3 2xl:px-4 2xl:py-2 transition-all duration-200 active:scale-95 cursor-pointer shadow-xs uppercase shrink-0"
            >
              <div class="text-[#d79900] dark:text-[#ffd688]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-trello"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <rect x="7" y="7" width="3" height="9"></rect>
                  <rect x="14" y="7" width="3" height="5"></rect>
                </svg>
              </div>
              <span>Sample Strategies</span>
            </router-link>
          </div>
        </div>

        <div v-if="initials" class="flex items-center gap-1.5 xl:gap-2 2xl:gap-3 shrink-0">
          <router-link
            v-if="initials"
            :to="{ name: 'MarketMeter' }"
            class="text-[11px] xl:text-xs font-semibold text-slate-700 dark:text-slate-300 bg-white/80 dark:bg-zinc-800/80 hover:bg-amber-500/10 dark:hover:bg-amber-500/20 hover:text-amber-700 dark:hover:text-[#ffd688] hover:border-amber-500/40 gap-1.5 2xl:gap-2 whitespace-nowrap flex items-center border border-slate-200 dark:border-zinc-700/80 rounded-full px-2.5 py-1.5 xl:px-3 2xl:px-4 2xl:py-2 transition-all duration-200 active:scale-95 cursor-pointer shadow-xs uppercase shrink-0"
          >
            <div class="text-[#d79900] dark:text-[#ffd688]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-activity"
              >
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <span>Market Meter</span>
          </router-link>

          <router-link
            v-if="initials"
            :to="{ name: 'DashboardPage' }"
            class="text-[11px] xl:text-xs font-semibold text-slate-700 dark:text-slate-300 bg-white/80 dark:bg-zinc-800/80 hover:bg-amber-500/10 dark:hover:bg-amber-500/20 hover:text-amber-700 dark:hover:text-[#ffd688] hover:border-amber-500/40 gap-1.5 2xl:gap-2 whitespace-nowrap flex items-center border border-slate-200 dark:border-zinc-700/80 rounded-full px-2.5 py-1.5 xl:px-3 2xl:px-4 2xl:py-2 transition-all duration-200 active:scale-95 cursor-pointer shadow-xs uppercase shrink-0"
          >
            <div class="text-[#d79900] dark:text-[#ffd688]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-monitor"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
            </div>
            <span>Dashboard</span>
          </router-link>

          <router-link :to="{ name: 'CreatePage', query: { pageType: 'Real' } }" class="shrink-0">
            <button
              type="button"
              class="flex items-center gap-1.5 2xl:gap-2 hover:bg-amber-500/10 dark:hover:bg-zinc-800/60 pl-1.5 pr-2.5 xl:pr-3 py-1 2xl:pl-2 2xl:pr-4 2xl:py-1.5 rounded-full transition-colors cursor-pointer"
            >
              <div class="text-[#d79900] dark:text-[#ffd688]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-plus-circle"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
              </div>
              <div>
                <div
                  class="text-[11px] xl:text-xs uppercase font-semibold text-slate-700 dark:text-slate-200 text-left"
                >
                  Investing Strategy
                </div>
                <div
                  class="bg-gradient-to-r from-[#ffd688] to-[#d79900] h-[3px] w-8 rounded-full"
                ></div>
              </div>
            </button>
          </router-link>

          <router-link :to="{ name: 'CreateTradingPage' }" class="shrink-0">
            <button
              type="button"
              class="flex items-center gap-1.5 2xl:gap-2 hover:bg-amber-500/10 dark:hover:bg-zinc-800/60 pl-1.5 pr-2.5 xl:pr-3 py-1 2xl:pl-2 2xl:pr-4 2xl:py-1.5 rounded-full transition-colors cursor-pointer"
            >
              <div class="text-[#d79900] dark:text-[#ffd688]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-plus-circle"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
              </div>
              <div>
                <div
                  class="text-[11px] xl:text-xs uppercase font-semibold text-slate-700 dark:text-slate-200 text-left"
                >
                  Trading Strategy
                </div>
                <div
                  class="bg-gradient-to-r from-[#ffd688] to-[#d79900] h-[3px] w-8 rounded-full"
                ></div>
              </div>
            </button>
          </router-link>

          <router-link :to="{ name: 'MFCreatePage' }" class="shrink-0">
            <button
              type="button"
              class="flex items-center gap-1.5 2xl:gap-2 hover:bg-amber-500/10 dark:hover:bg-zinc-800/60 pl-1.5 pr-2.5 xl:pr-3 py-1 2xl:pl-2 2xl:pr-4 2xl:py-1.5 rounded-full transition-colors cursor-pointer"
            >
              <div class="text-[#d79900] dark:text-[#ffd688]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-plus-circle"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
              </div>
              <div>
                <div
                  class="text-[11px] xl:text-xs uppercase font-semibold text-slate-700 dark:text-slate-200 text-left"
                >
                  MF Strategy
                </div>
                <div
                  class="bg-gradient-to-r from-[#ffd688] to-[#d79900] h-[3px] w-8 rounded-full"
                ></div>
              </div>
            </button>
          </router-link>

          <button
            type="button"
            class="p-1.5 2xl:p-2 rounded-full hover:bg-amber-500/10 dark:hover:bg-zinc-800 text-slate-600 dark:text-slate-300 transition-colors cursor-pointer flex items-center justify-center border border-transparent hover:border-slate-200 dark:hover:border-zinc-700 shrink-0"
            @click="toggleDark()"
          >
            <div class="moon-icon w-5 h-5 flex items-center justify-center">
              <img src="./assets/moon-dark.svg" class="w-5 h-5" />
            </div>
            <div class="sun-icon w-5 h-5 flex items-center justify-center">
              <img src="./assets/sun-light.svg" class="w-5 h-5" />
            </div>
          </button>

          <!-- Profile dropdown -->
          <HeadlessMenu v-if="initials" as="div" class="relative inline-block text-left shrink-0">
            <div>
              <MenuButton
                class="rounded-full p-1.5 2xl:p-2 h-8 w-8 2xl:h-9 2xl:w-9 text-center text-xs font-bold text-slate-950 shadow-sm bg-gradient-to-br from-[#ffd688] to-[#d79900] uppercase flex items-center justify-center cursor-pointer active:scale-95 transition-transform"
              >
                {{ initials }}
              </MenuButton>
            </div>

            <transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <MenuItems
                class="absolute right-0 z-50 mt-2.5 origin-top-right divide-y divide-slate-100 dark:divide-zinc-800/80 rounded-2xl shadow-xl px-4 py-2 border border-slate-200 dark:border-zinc-800 bg-white dark:bg-[#0f131c] focus:outline-none backdrop-blur-md"
              >
                <div
                  class="py-2 text-left text-slate-800 dark:text-slate-200 text-sm font-semibold"
                >
                  {{ getUserDetails.firstname + ' ' + getUserDetails.lastname }}
                </div>
                <div class="py-2 text-left text-slate-500 dark:text-zinc-400 text-xs">
                  {{ getUserDetails.email }}
                </div>
                <div class="py-2 flex items-center justify-start text-sm cursor-pointer">
                  <MenuItem v-slot="{ active }">
                    <a
                      :class="[
                        active
                          ? 'text-[#d79900] dark:text-[#ffd688]'
                          : 'text-slate-700 dark:text-slate-200',
                        'group flex items-center text-sm font-medium transition-colors w-full cursor-pointer'
                      ]"
                      @click="onLogout()"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        class="mr-3 h-5 w-5"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M3 4.25A2.25 2.25 0 015.25 2h5.5A2.25 2.25 0 0113 4.25v2a.75.75 0 01-1.5 0v-2a.75.75 0 00-.75-.75h-5.5a.75.75 0 00-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-2a.75.75 0 011.5 0v2A2.25 2.25 0 0110.75 18h-5.5A2.25 2.25 0 013 15.75V4.25z"
                          clip-rule="evenodd"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          d="M6 10a.75.75 0 01.75-.75h9.546l-1.048-.943a.75.75 0 111.004-1.114l2.5 2.25a.75.75 0 010 1.114l-2.5 2.25a.75.75 0 11-1.004-1.114l1.048-.943H6.75A.75.75 0 016 10z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Log Out
                    </a>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </HeadlessMenu>
        </div>
        <div v-else class="flex items-center gap-4">
          <button
            type="button"
            class="cta-gradient !text-black font-bold px-6 py-2 rounded-full text-xs shadow-sm hover:scale-[1.03] transition-all cursor-pointer"
            @click="ssoLogin()"
          >
            <span class="text-xs">Login</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="block lg:hidden sticky top-0 z-50 shrink-0 border-b border-slate-200 dark:border-zinc-800/80 bg-white/90 dark:bg-[#0f131c]/90 backdrop-blur-md transition-colors duration-300"
  >
    <div class="container px-4 py-2.5">
      <div class="relative flex justify-between items-center w-full">
        <router-link :to="{ name: 'DashboardPage' }">
          <img
            class="h-9 w-auto inline dark:hidden"
            src="./assets/Momentum-light-Logo.svg"
            alt="Momentify Logo"
          />

          <img
            class="h-9 w-auto hidden dark:inline"
            src="./assets/Momentum-dark-Logo.svg"
            alt="Momentify Logo"
          />
        </router-link>
        <div class="flex justify-end gap-2 items-center">
          <button
            type="button"
            class="text-slate-600 dark:text-slate-300 p-1.5"
            @click="toggleDark()"
          >
            <div class="moon-icon">
              <img src="./assets/moon-dark.svg" />
            </div>
            <div class="sun-icon">
              <img src="./assets/sun-light.svg" class="text-gray-500" />
            </div>
          </button>
          <HeadlessMenu v-if="initials" as="div" class="relative inline-block text-left">
            <div>
              <MenuButton
                class="inline-flex justify-center items-center rounded-full bg-gradient-to-br from-[#ffd688] to-[#d79900] p-2 h-9 w-9 text-xs font-bold text-black shadow-sm"
              >
                {{ initials }}
              </MenuButton>
            </div>

            <transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <MenuItems
                class="absolute right-0 z-50 mt-2.5 origin-top-right divide-y divide-slate-100 dark:divide-zinc-800/80 rounded-2xl shadow-xl px-4 py-2 border border-slate-200 dark:border-zinc-800 bg-white dark:bg-[#0f131c]"
              >
                <div
                  class="py-2 text-left text-slate-800 dark:text-slate-200 text-sm font-semibold"
                >
                  {{ getUserDetails.firstname + ' ' + getUserDetails.lastname }}
                </div>
                <div class="py-2 text-left text-slate-500 dark:text-zinc-400 text-xs">
                  {{ getUserDetails.email }}
                </div>
                <div class="py-2 flex items-center justify-start text-sm cursor-pointer">
                  <MenuItem v-slot="{ active }">
                    <a
                      :class="[
                        active
                          ? 'text-[#d79900] dark:text-[#ffd688]'
                          : 'text-slate-700 dark:text-slate-200',
                        'group flex items-center text-sm font-medium transition-colors'
                      ]"
                      @click="onLogout()"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        class="mr-3 h-5 w-5"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M3 4.25A2.25 2.25 0 015.25 2h5.5A2.25 2.25 0 0113 4.25v2a.75.75 0 01-1.5 0v-2a.75.75 0 00-.75-.75h-5.5a.75.75 0 00-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-2a.75.75 0 011.5 0v2A2.25 2.25 0 0110.75 18h-5.5A2.25 2.25 0 013 15.75V4.25z"
                          clip-rule="evenodd"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          d="M6 10a.75.75 0 01.75-.75h9.546l-1.048-.943a.75.75 0 111.004-1.114l2.5 2.25a.75.75 0 010 1.114l-2.5 2.25a.75.75 0 11-1.004-1.114l1.048-.943H6.75A.75.75 0 016 10z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Log Out
                    </a>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </HeadlessMenu>
        </div>
      </div>
    </div>
    <div
      class="bg-slate-50 dark:bg-[#0b0f17] px-4 py-2 border-t border-slate-200 dark:border-zinc-800/80"
    >
      <div v-if="initials">
        <div
          class="flex items-center justify-start overflow-x-auto whitespace-nowrap pb-2 text-xs md:text-sm gap-4 mb-2"
        >
          <router-link :to="{ name: 'LearnPage' }">
            <button
              type="button"
              class="p-2 text-slate-700 dark:text-slate-300 hover:text-amber-600 dark:hover:text-[#ffd688] font-semibold text-xs transition-colors"
            >
              Learn
            </button>
          </router-link>
          <router-link :to="{ name: 'MarketRegimePage' }">
            <button
              type="button"
              class="p-2 text-slate-700 dark:text-slate-300 hover:text-amber-600 dark:hover:text-[#ffd688] font-semibold text-xs transition-colors"
            >
              Market Regime
            </button>
          </router-link>
          <router-link :to="{ name: 'DashboardPage' }">
            <button
              type="button"
              class="p-2 text-slate-700 dark:text-slate-300 hover:text-amber-600 dark:hover:text-[#ffd688] font-semibold text-xs transition-colors"
            >
              Dashboard
            </button>
          </router-link>
          <router-link :to="{ name: 'SampleStrategiesPage' }">
            <button
              type="button"
              class="p-2 text-slate-700 dark:text-slate-300 hover:text-amber-600 dark:hover:text-[#ffd688] font-semibold text-xs transition-colors"
            >
              Sample Strategies
            </button>
          </router-link>
        </div>

        <div
          class="flex items-center justify-start overflow-x-auto whitespace-nowrap pb-1 text-xs gap-3"
        >
          <router-link :to="{ name: 'CreatePage', query: { pageType: 'Real' } }">
            <button
              type="button"
              class="border border-amber-500/40 bg-amber-500/10 hover:bg-gradient-to-r hover:from-[#ffd688] hover:to-[#d79900] hover:!text-black text-amber-700 dark:text-[#ffd688] rounded-full px-4 py-1.5 font-bold text-xs transition-all flex items-center gap-1"
            >
              <span class="font-bold">+</span>
              <span>Investing</span>
            </button>
          </router-link>
          <router-link :to="{ name: 'CreateTradingPage' }">
            <button
              type="button"
              class="border border-amber-500/40 bg-amber-500/10 hover:bg-gradient-to-r hover:from-[#ffd688] hover:to-[#d79900] hover:!text-black text-amber-700 dark:text-[#ffd688] rounded-full px-4 py-1.5 font-bold text-xs transition-all flex items-center gap-1"
            >
              <span class="font-bold">+</span>
              <span>Trading</span>
            </button>
          </router-link>
          <router-link :to="{ name: 'MFCreatePage' }">
            <button
              type="button"
              class="border border-amber-500/40 bg-amber-500/10 hover:bg-gradient-to-r hover:from-[#ffd688] hover:to-[#d79900] hover:!text-black text-amber-700 dark:text-[#ffd688] rounded-full px-4 py-1.5 font-bold text-xs transition-all flex items-center gap-1"
            >
              <span class="font-bold">+</span>
              <span>MF</span>
            </button>
          </router-link>
        </div>
      </div>
      <button
        v-else
        type="button"
        class="cta-gradient !text-black font-bold px-6 py-2 rounded-full text-xs shadow-sm hover:scale-[1.03] transition-all cursor-pointer"
        @click="ssoLogin()"
      >
        <span>Login</span>
      </button>
    </div>
  </div>
  <router-view :key="$route.fullPath" />
</template>
<script lang="ts">
import { useCommonStore } from '@/store/commonStore'

import { toRefs } from '@vueuse/core'
import { defineComponent, onMounted, reactive, computed } from 'vue'
import apiClient from './config/axios'
import router from '@/router'
import { useRoute } from 'vue-router'
import { Menu as HeadlessMenu, MenuItem, MenuButton, MenuItems } from '@headlessui/vue'
import { useStrategyStore } from './store/momentumStore'
import { useDark, useToggle } from '@vueuse/core'

import LearnIcon from './assets/Learn-Icon.svg'
// import AiAssistant from './views/AiAssistant.vue'

export default defineComponent({
  name: 'App',
  components: { HeadlessMenu, MenuButton, MenuItems, MenuItem },
  setup() {
    const isDark = useDark()
    const toggleDark = useToggle(isDark)
    const strategyStore = useStrategyStore()
    const commonStore = useCommonStore()
    const route = useRoute()
    const state = reactive({
      isAuthenticated: false,
      sidebarOpen: false,
      getUserDetails: computed(() => commonStore.getUserDetails),
      initials: computed(() => {
        const firstchar = commonStore?.getUserDetails.firstname?.[0]?.split('')?.[0]
        const secondchar = commonStore?.getUserDetails.lastname?.[0]?.split('')?.[0]
        const finalchar = firstchar + secondchar
        return finalchar
      })
    })

    const ssoLogin = async () => {
      try {
        const removeV1 = import.meta.env.VITE_ENDPOINT_URL
        state.isAuthenticated = false
        window.location.href = `${removeV1}/ssologin`
        const response = await apiClient.get('/session')
        if (
          response.status == 401 ||
          response.headers['content-type'] === 'text/html;charset=utf-8'
        ) {
          const removeV1 = import.meta.env.VITE_ENDPOINT_URL
          window.location.href = `${removeV1}/ssologin`
          return false
        }

        commonStore.fetchUserDetails({
          firstname: response.data.firstname,
          lastname: response.data.lastname,
          email: response.data.email,
          role: response.data.Userrole,
          ucc: response.data.loginId
        })

        state.isAuthenticated = true
        return true
      } catch (error) {
        state.isAuthenticated = false
        console.error('Session check failed:', error)
        const removeV1 = import.meta.env.VITE_ENDPOINT_URL?.toString()
        window.location.href = `${removeV1}/ssologin`
        return false
      }
    }

    const checkSession = async () => {
      try {
        const response = await apiClient.get('/session')
        if (
          response.status == 401 ||
          response.headers['content-type'] === 'text/html;charset=utf-8'
        ) {
          // const removeV1 = import.meta.env.VITE_ENDPOINT_URL?.toString()
          // window.location.href = `${removeV1}/ssologin`
          return false
        }

        commonStore.fetchUserDetails({
          firstname: response.data.firstname,
          lastname: response.data.lastname,
          email: response.data.email,
          role: response.data.Userrole,
          ucc: response.data.loginId
        })

        state.isAuthenticated = true
        return true
      } catch (error) {
        console.error('Session check failed:', error)
        // const removeV1 = import.meta.env.VITE_ENDPOINT_URL?.toString()
        // window.location.href = `${removeV1}/ssologin`
        return false
      }
    }

    router.beforeEach(async (to, from, next) => {
      if (to.name === 'HomePage' && from.name === undefined) {
        next()
        return
      }

      if (!state.isAuthenticated) {
        await checkSession()
      }
      next()
    })

    function onLogout() {
      strategyStore.logoutSession()
    }

    const navigateAndClose = (closeFn?: () => void, routeName?: string) => {
      if (typeof closeFn === 'function') {
        closeFn()
      }
      if (routeName) {
        router.push({ name: routeName })
      }
    }

    onMounted(async () => {
      const currentRoute = route.name
      if (currentRoute === 'HomePage') {
        return
      }
      await checkSession()
    })

    return {
      ...toRefs(state),
      ssoLogin,
      checkSession,
      onLogout,
      navigateAndClose,
      HeadlessMenu,
      MenuButton,
      MenuItems,
      toggleDark,
      LearnIcon
    }
  }
})
</script>
<style>
.videowrapper {
  float: none;
  clear: both;
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;
}
.videowrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 20px;
  border-radius: 30px;
}
.color-overly-1 {
  position: absolute;
  top: 240px;
  left: 100px;
  height: 450px;
  width: 450px;
  border-radius: 50%;
  opacity: 0.2;
  background: linear-gradient(93deg, #b324d7 7.07%, #fe577f 97.81%);
  filter: blur(114px);
  z-index: -1;
}
.color-overly-2 {
  position: absolute;
  top: -175px;
  right: 0px;
  height: 500px;
  width: 500px;
  border-radius: 50%;
  opacity: 0.2;
  background: linear-gradient(180deg, #6243ff 0%, #b324d7 100%);
  filter: blur(90px);
  z-index: -1;
}

.staranimation1 {
  position: absolute;
  top: -6px;
  right: -17px;
}

.staranimation1 img {
  width: auto;
}

.staranimation2 {
  position: absolute;
  top: -6px;
  right: -8px;
}

.staranimation2 img {
  width: auto;
}

.staranimation3 {
  position: absolute;
  bottom: 83px;
  left: 518px;
}

.staranimation3 img {
  width: auto;
}

.staranimation4 {
  position: absolute;
  bottom: 13px;
  left: 102px;
}

.staranimation4 img {
  width: auto;
}

.starzoom {
  animation-duration: starzoom 10s infinite;
  animation: starzoom 3s ease-out infinite;
}
@keyframes starzoom {
  0% {
    rotate: (0deg);
    transform: scale(0, 0);
  }
  50% {
    transform: scale(1, 1);
  }
  100% {
    rotate: (360deg);
    transform: scale(0, 0);
  }
}

.animation-pulse {
  /*box-shadow: 0 0 0 20px rgba(229,62,62, 0.5);
    transform: scale(0.8);*/
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.664);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(229, 62, 62, 0);
  }

  100% {
    transform: scale(1);
  }
}

.cta-gradient {
  background: linear-gradient(135deg, #ffd688 0%, #d79900 100%);
  color: #000000 !important;
  font-weight: 700;
  transition: all 0.3s ease;
}
.cta-gradient:hover {
  background: linear-gradient(135deg, #ffe0a3 0%, #e5a700 100%);
  box-shadow: 0 6px 20px rgba(215, 153, 0, 0.4);
}
</style>
